module.exports = __webpack_public_path__ + "static/media/cover3.e1cf4ca9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cards/cover/cover3.jpg
// module id = 1556
// module chunks = 0